import React, { useState } from "react";
import Button from "../components/Button";
import Tag from "../components/Tag";
import Avatar from "../components/Avatar";
import { FieldGroup, InputGroup, InputPassword } from "../components/Input";
import Checkbox from "../components/Checkbox";
import Radio from "../components/RadioBtn";
import NavTab from "../components/NavTab";
// import CardsContainer from "../layout/CardsContainer";
import Thumbnail from "../img/tmp/thumbnails/1.jpg";
// import Avatar1 from "../img/tmp/avatars/1.png";
import GameThumbnail from "../img/tmp/thumbnails/games/1.jpg";
// import Switch from "../components/Switch";

// Import Images tmp
import AvatarImg from "../img/tmp/avatars/big.jpg";
import { ReactComponent as VideoIcon } from "../img/icons/video.svg";
import { ReactComponent as UserIcon } from "../img/icons/user.svg";
import { Container } from "../layout/Container";
// import Card from "../components/Cards";
import GameCard from "../components/cards/Game";
import LiveCard from "../components/cards/Live";

const Components = () => {
  const [index, setIndex] = useState(4);
  const list = ["forms", "typography", "buttons", "cards", "others"];
  return (
    <Container>
      <NavTab list={list} index={index} setIndex={setIndex} />
      {index === 1 && <Forms />}
      {index === 2 && <Typography />}
      {index === 3 && <Buttons />}
      {index === 4 && <Cards />}
      {index === 5 && <Others />}
    </Container>
  );
};

const Forms = () => {
  const [checked, setChecked] = useState(false);

  const handleRadioBtn = (e) => {
    console.log(e.target.value);
  };
  const handleCheckbox = () => {
    setChecked(!checked);
  };
  return (
    <form action="/">
      <FieldGroup label="password" link>
        <InputPassword placeholder="Enter password" />
      </FieldGroup>
      <br />
      <FieldGroup label="label">
        <InputGroup
          placeholder="example@gmail.com"
          type="email"
          iconLeft={UserIcon}
          alert="Invalid email address."
        />
      </FieldGroup>
      {/* <TextArea /> */}
      <br />
      <label>
        <Checkbox checked={checked} onChange={handleCheckbox} />
        <span>I agree to the Terms of Service and Privacy Policy</span>
      </label>
      <br />
      <br />
      <div onChange={handleRadioBtn}>
        <Radio value="players" name="participants" text="Players" />
        <Radio value="teams" name="participants" text="Teams" />
      </div>
      <br />
      <br />
      <Button type="submit" variant="primary">
        Submit
      </Button>
    </form>
  );
};
const Typography = () => (
  <>
    <h1>Heading 1</h1>
    <h2>Heading 2</h2>
    <h3>Heading 3</h3>
    <h4>Heading 4</h4>
    <h5>Heading 5</h5>
    <h6>Heading 6</h6>
    <p className="large">Large paragraphe</p>
    <p>Default paragraphe</p>
    <p className="small">Small paragraphe</p>
    <label htmlFor="">Label</label>
  </>
);
const Buttons = () => (
  <>
    <Button variant="danger">
      <VideoIcon />
      Danger
    </Button>
    <br />
    <br />
    <Button icon>
      <VideoIcon />
    </Button>
    <Button variant="secondary" icon>
      <VideoIcon />
    </Button>
    <br />
    <br />
    <Button>
      <VideoIcon />
      Button
      <VideoIcon />
    </Button>
    <br />
    <br />
    <Button to="/">Link</Button>
    <br />
    <br />
    <Button to="/" variant="secondary">
      <VideoIcon />
      Secondary
      <VideoIcon />
    </Button>
    <br />
    <br />
    <Button to="/52" variant="primary">
      <VideoIcon />
      Primary
      <VideoIcon />
    </Button>
    <br />
    <br />
    <Button to="/" variant="primary" size="large">
      <VideoIcon />
      Button Large
      <VideoIcon />
    </Button>
    <br />
    <br />
    <Button to="/" variant="primary" size="small">
      <VideoIcon />
      Button Small
      <VideoIcon />
    </Button>
    <br />
    <br />
    <Button to="/hgf" disabled={true}>
      <VideoIcon />
      Disabled
      <VideoIcon />
    </Button>
    <br />
    <br />
    <Button to="/" outline="true">
      <VideoIcon />
      outline
      <VideoIcon />
    </Button>
    <br />
    <br />
  </>
);
const Cards = () => {
  return (
    <>
      <LiveCard
        to=""
        title="title"
        thumbnail={Thumbnail}
        tags={["tag1", "tag2"]}
        avatar={AvatarImg}
        verified={true}
        username="username"
        gif={GameThumbnail}
      />
      <LiveCard
        horizontal
        to=""
        title="title"
        thumbnail={Thumbnail}
        tags={["tag1", "tag2"]}
        avatar={AvatarImg}
        verified={true}
        username="username"
        gameName="Pubg"
        views={5333}
        gif={GameThumbnail}
      />

      <GameCard
        to="/game/test"
        name="Fortnite"
        thumbnail={GameThumbnail}
        tags={["hello", "world", "hello"]}
      />
      <GameCard
        horizontal
        description="The biggest, most dynamic and most diverse open world ever created,
        Grand Theft Auto V blends storytelling and gameplay in new ways as
        players repeatedly jump in and out of the lives of the game’s three lead
        characters, playing all sides of the game’s interwoven story."
        to="/game/test"
        name="Fortnite"
        thumbnail={GameThumbnail}
        tags={["hello", "world", "hello"]}
      />
      {/* <Card
        state={Cards[0].state}
        to={Cards[0].to}
        thumbnailImg={Cards[0].thumbnailImg}
        avatar={Avatar1}
        userURL={Cards[0].userURL}
        title={Cards[0].title}
        verified={Cards[0].verified}
        username={Cards[0].description}
        tags={Cards[0].tags}
        horizontal
      />
      <Card
        state={Cards[0].state}
        to={Cards[0].to}
        thumbnailImg={Cards[0].thumbnailImg}
        avatar={Avatar1}
        userURL={Cards[0].userURL}
        title={Cards[0].title}
        verified={Cards[0].verified}
        username={Cards[0].description}
        tags={Cards[0].tags}
      /> */}
      {/* <CardsContainer full="true" cardsselection={Cards} /> */}
    </>
  );
};
const Others = () => {
  return (
    <>
      <Avatar
        src={AvatarImg}
        alt="Ekuegan"
        size="90px"
        isLive
        isVerified
        followers="53710"
        name="Ekuegan"
      />
      <br />
      <br />
      <Avatar src={AvatarImg} alt="Ekuegan" />
      <br />
      <Tag to="/">Tag</Tag>
    </>
  );
};

export default Components;
